import request from '@/common/request'
export default {
  //用户增删改查
  createOrgTree: (dynaSeg, data, params) => {
    return request({
      url: '/org',
      method: 'post',
      data,
      params
    })
  },
  updateOrgTree: (dynaSeg, data, params) => {
    return request({
      url: `/org/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  deleteOrgTree: (dynaSeg, data, params) => {
    return request({
      url: `/org/delOrg/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  queryOrgTree: params => {
    return request({
      url: '/org/0',
      method: 'get',
      params
    })
  },
  getOrgById: dynaSeg => {
    return request({
      url: `/org/getOrgById/${dynaSeg.id}`,
      method: 'get'
    })
  },
  orgFileUpload:  (data, config) => {
    return request({
      url: '/org/orgFileUpload',
      method: 'post',
      data,
      config,
      timeout: 360000,
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/org.js